export type LogoMode = 'cobranded' | 'whitelabel';

export interface NamePageConfig {
  projectdescription?: string;
  presentationstatus?: string;

  clientLogoUrl?: string;
  welcomeTitle?: string;
  welcomeMessage?: string;
  isExternal?: boolean;
  logoMode?: LogoMode;
}

// TODO: replace with the BI bucket prefix once coordinated with infra/admin team.
export const LOGO_HOST_ALLOWLIST: readonly string[] = [
  'TODO_LOGO_HOST_ALLOWLIST',
];

export function isAllowedLogoUrl(url: string | undefined | null): boolean {
  if (!url) {
    return false;
  }
  return LOGO_HOST_ALLOWLIST.some((prefix) => url.startsWith(prefix));
}
